import { studentCodes, useMembershipTypes } from "./membership";

function checkShowFors(
  showFors,
  hideFors,
  skipIfLoggedIn,
  statusCode,
  isLoggedIn,
) {
  if (showFors) return showFors.includes(statusCode);

  if (hideFors) return !hideFors.includes(statusCode);

  if (skipIfLoggedIn) return !isLoggedIn;

  return true;
}

export function filterPages(pages, isLoggedIn) {
  const { statusCode } = useMembershipTypes();
  return pages.filter((i) =>
    checkShowFors(
      i.showForMemTypes,
      i.hideForMemTypes,
      i.skipIfLoggedIn,
      statusCode.value,
      isLoggedIn && isLoggedIn.value,
    ),
  );
}

export function goToPreviousPage(route) {
  const { statusCode } = useMembershipTypes();
  const to = {
    name: "",
  };
  let currentPage = route.currentRoute.query.currentPage;
  switch (route.currentRoute.name) {
    case "Contact Details":
      if (!currentPage) to.name = "Getting Started";
      else {
        to.name = route.currentRoute.name;
        if (!to.query) to.query = {};
        to.query.currentPage = (currentPage ?? 0) - 1;
      }
      break;
    case "Work Details":
      to.name = "Contact Details";
      break;
    case "Place of Study":
      if (studentCodes.includes(statusCode.value)) {
        to.name = "Contact Details";
      } else {
        to.name = "Work Details";
      }
      break;
    case "Diversity Details": {
      to.name = "Place of Study";
      break;
    }
    case "Review":
      to.name = "Diversity Details";
      break;
  }

  route.push(to);
}
